import { OrbitLTariff, TerminalFinancingModel } from "Infrastructure/Api/Api";
import z from "zod";

export const productPricingSchema = z.object({
  productPricingID: z.number().optional(),
  tariff: z.enum(OrbitLTariff).nullish(),
  financingModel: z.enum(TerminalFinancingModel),
});

export type ProductPricingFormData = z.infer<typeof productPricingSchema>;
